/* eslint-disable @typescript-eslint/no-explicit-any */
// We want to know if the type extends "any" Promise, so here the explicit any
// is needed
import timeout from '../lib/timeout';

export const timeoutPromise = <T>(
  ms: number,
  callback: () => T
): T extends Promise<any> ? T : Promise<T> =>
  new Promise((resolve, reject) =>
    timeout(() => {
      try {
        resolve(callback());
      } catch (e) {
        reject(e);
      }
    }, ms)
  ) as T extends Promise<any> ? T : Promise<T>;
